import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { LessonOptionStatus } from '../../models/LessonOption';
import { passMetaChipSx } from '../passes/passDetailLayout';

const statusLabel = (t: (key: string, fallback: string) => string, status: LessonOptionStatus) => {
  switch (status) {
    case 'ACTIVE':
      return t('hostLessonOptions.statusActive', 'Active');
    case 'INACTIVE':
      return t('hostLessonOptions.statusDraft', 'Draft');
    case 'ARCHIVED':
      return t('hostLessonOptions.statusArchived', 'Archived');
  }
};

export interface LessonOptionStatusChipProps {
  status: LessonOptionStatus;
}

/** Outlined catalog status chip — same size as pass type/status chips. */
const LessonOptionStatusChip: React.FC<LessonOptionStatusChipProps> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <Chip
      label={statusLabel(t, status)}
      color={status === 'ACTIVE' ? 'success' : 'default'}
      size="small"
      variant="outlined"
      sx={passMetaChipSx}
    />
  );
};

export default LessonOptionStatusChip;
